import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export const Navbar = () => {
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 w-full backdrop-blur-xl bg-white/80 border-b border-[#E7E5E4]"
    >
      <div className="container-x flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-xl bg-[#064E3B] flex items-center justify-center">
            <Sparkles className="h-5 w-5 text-[#F59E0B]" />
          </div>
          <div className="font-display font-black text-lg text-[#064E3B] leading-none">
            5GB<span className="text-[#C2410C]">.</span>
            <span className="hidden sm:inline"> Corporation</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-[#1C1917]">
          <a href="#how" data-testid="nav-how" className="hover:text-[#C2410C]">How it works</a>
          <a href="#products" data-testid="nav-products" className="hover:text-[#C2410C]">Products</a>
          <a href="#calculator" data-testid="nav-calculator" className="hover:text-[#C2410C]">Earnings</a>
          <a href="#register" data-testid="nav-register" className="hover:text-[#C2410C]">Register</a>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/login"
            data-testid="nav-admin-login"
            className="hidden sm:inline-flex text-xs font-bold uppercase tracking-[0.15em] text-[#57534E] hover:text-[#064E3B]"
          >
            Admin
          </Link>
          <a
            href="#register"
            data-testid="nav-cta"
            className="pill-btn pill-btn-primary text-sm"
          >
            Start Earning
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
